export default __webpack_public_path__ + "static/media/pet-cloud-card-logo.d754bc73.svg";